// extracted by mini-css-extract-plugin
export default {"root":"card-metric_root__sruyh","suffix":"card-metric_suffix__RrtWd","iconWrapper":"card-metric_iconWrapper__xpZBq"};